import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  IngredientGroup,
  ingredientGroupResource,
} from "@megarax/client/src/resources/plm";
import { getDefaultModuleComponents } from "@/components/nameResource/components";

export const ingredientGroupModule: ResourceAppModule = {
  ...getDefaultModuleComponents(ingredientGroupResource),
  route: "frakcjaSkladnikow",
  title: "Frakcje składników",
  app: plmApp,
  itemConstructor: IngredientGroup,
  resource: ingredientGroupResource,
  iconClass: "",
};
